import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=62d406c6&scoped=true"
import script from "./Comparison.vue?vue&type=script&lang=ts"
export * from "./Comparison.vue?vue&type=script&lang=ts"
import style0 from "./Comparison.vue?vue&type=style&index=0&id=62d406c6&prod&scoped=true&lang=css"
import style1 from "./Comparison.vue?vue&type=style&index=1&id=62d406c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d406c6",
  null
  
)

export default component.exports